<template lang="pug">
  v-toolbar(height="86" flat class="mb-2")
    v-row(no-gutters)
      HeaderTop
      HeaderBottom
</template>

<script>
export default {
  components: {
    HeaderBottom: () => import('@/components/Header/HeaderBottom.vue'),
    HeaderTop: () => import('@/components/Header/HeaderTop.vue')
  }
}
</script>
